<template>
  <div class="app-download">
    <p class="app-download__msg">{{ message }}</p>
  </div>
</template>

<script>
import { getPublicContentByCode } from '@/api/modules/params'

export default {
  name: 'AppDownload',
  data() {
    return {
      message: '正在跳转，请稍候...'
    }
  },
  async mounted() {
    // 当前路由 path 即为 param_content 的 code（如 /app/a、/app/o）
    const code = this.$route.path
    try {
      const res = await getPublicContentByCode(code)
      const content = res && res.result && res.result.content
      if (content) {
        // 跳转到参数配置的地址
        window.location.replace(content)
      } else {
        this.message = '未找到下载地址配置'
      }
    } catch (e) {
      this.message = '获取下载地址失败，请稍后重试'
    }
  }
}
</script>

<style scoped lang="scss">
.app-download {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;

  &__msg {
    font-size: 16px;
    color: #666;
  }
}
</style>
